<template>
  <div>
    <custom-actions title="订餐统计" class="mt10">
      <template #header>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="startDate" label="统计日期">
          <el-date-picker type="daterange" @change="onDateChange" v-model="dateArr" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border :data="tableData">
        <el-table-column min-width="120" label="订餐点" prop="isMeal">
          <template v-slot="{ row }">
            {{ isMealFormatMap.get(row.isMeal) }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="订餐数量" prop="mealNum"></el-table-column>
      </el-table>

      <!-- <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination> -->
    </el-card>

  </div>
</template>

<script>
import { isMealFormat } from '@/utils/dict'
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'OrderStatistics',
  mixins: [keepAlive],

  data() {
    return {
      isMealFormatMap: isMealFormat,
      dateArr: [],
      tableData: [],
      page: 1,
      total: 0,
      searchForm: {
        startDate: '',
        endDate: ''
      }
    }
  },
  computed: {
  },
  created() {
    this.loadData()
  },
  methods: {
    onDateChange(val) {
      if (val.length) {
        this.searchForm.startDate = val[0]
        this.searchForm.endDate = val[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleMealByList, this.searchForm).then(res => {
        this.tableData = res || []
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset(formName) {
      this.$refs.searchForm.resetFields()
    }
  }
}
</script>
<style lang="scss" scoped></style>
